import { render } from "./DefaultPostSectionDocCmp.vue?vue&type=template&id=05ee786e"
import script from "./DefaultPostSectionDocCmp.vue?vue&type=script&lang=js"
export * from "./DefaultPostSectionDocCmp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__